<template>
  <div>
    <div v-for="(item, index) in listData" :key="index">
    <div class="flex flex-space-between flex-align-center margin-5">
      <div
        class="flex flex-justify-around flex-align-center wpercent80 height-80 fc-white bg-008c8c border-radius-5"
      >
        <div class="fs-18">
          <div class="flex flex-space-between flex-align-center">
            <span class="fs-24 font-bold">{{ item.fullName }}</span>
            <span>{{ item.gender === '0' ? '男' : '女' }}</span>
            <span>{{ item.age }}岁</span>
          </div>
          <span>手机号：{{ item.mobile }}</span>
        </div>
        <div
          class="flex flex-align-center flex-direction-column flex-justify-center"
        >
          <span class="display-block">状态变更时间</span
          ><span class="display-block">{{ item.updataBy }}</span
          ><span class="display-block fs-18 button font-bold">{{ item.dataStata }}</span>
        </div>
      </div>
      <div
        class="flex wperenct20 height-80 fc-white bg-white border-radius-5 dotted"
      >
        <span class="bg-008c8c button margin-auto" @click="click(item)">{{ buttonText }}</span>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    buttonText: { type: String, required: false, default: "删除" },
    listData: [],
  },
  data() {
    return {};
  },
  methods: {
    // 操作按钮
    click(obj) {
      this.$emit('click', obj);
    },
  },
};
</script>

<style lang="less">
.dotted {
  border-left-width: 1px;
  border-left-color: #fff;
  border-left-style: dashed;
}
.button {
  font-size: 0.5rem;
  display: inline-block;
  padding: 0 5px;
  border: 1px solid #fff;
  border-radius: 3px;
}
</style>
